export default "__VITE_PUBLIC_ASSET__e8735c75__"